export default "__VITE_ASSET__ghekrloh__"